/* eslint-disable no-alert */
import { Box, Image } from '@chakra-ui/react';

import type { JSX } from "react";

export type BlueprintImageProps = {
	image: string;
};

export const BlueprintImage = ({ image }: BlueprintImageProps): JSX.Element => {
	const isFullUrl = !!image && /^https?:\/\//i.test(image);
	const isFilename = !!image && !isFullUrl && image.length < 1000;
	const imageSrc = isFullUrl
		? image
		: isFilename
			? `${import.meta.env.VITE_BLUEPRINT_IMAGES_BASE_URL}/${image}`
			: image ? `data:image/jpeg;base64,${image}` : '';
	return (
		<Box marginBottom="10px" width="100%" borderColor="gray.200" border="1px" rounded="15px" overflow="hidden">
			<Image
				objectFit="cover"
				objectPosition="middle"
				src={imageSrc} width="250px" height="150px" style={{ border: '1px rgb(50,50,50,0.1) solid', borderRadius: '4px' }}/>
		</Box>
	);
};
